import { slotsContext } from '@platforms/shared';
import {
	communicationService,
	context,
	TEMPLATE,
	TemplateStateHandler,
	UapParams,
	universalAdPackage,
} from '@wikia/ad-engine';
import { Inject, Injectable } from '@wikia/dependency-injection';
import { AD_ENGINE_UAP_NTC_LOADED } from '../../../../../communication/events/events-ad-engine-uap';

@Injectable({ autobind: false })
export class BfaaUcpDesktopConfigHandler implements TemplateStateHandler {
	private enabledSlots: string[] = [
		'top_boxad',
		'incontent_boxad',
		'bottom_leaderboard',
		'gallery_leaderboard',
		'quiz_leaderboard_start',
		'quiz_leaderboard_questions',
		'quiz_incontent',
		'quiz_leaderboard_finish',
	];
	constructor(@Inject(TEMPLATE.PARAMS) private params: UapParams) {}

	async onEnter(): Promise<void> {
		this.configureFloorAdhesion();
		document.querySelector('.top-ads-container')?.classList.remove('sticky-tlb-placeholder');

		if (this.params.newTakeoverConfig) {
			communicationService.emit(AD_ENGINE_UAP_NTC_LOADED);
		}

		universalAdPackage.init(
			this.params,
			this.enabledSlots,
			Object.keys(context.get('slots') || []).filter(
				(slotName) => !this.enabledSlots.includes(slotName),
			),
		);

		context.set('slots.bottom_leaderboard.viewportConflicts', []);

		slotsContext.setSlotSize(
			'bottom_leaderboard',
			universalAdPackage.UAP_ADDITIONAL_SIZES.bfaSize.desktop,
		);
		slotsContext.addSlotSize(
			'bottom_leaderboard',
			universalAdPackage.UAP_ADDITIONAL_SIZES.bfaSize.unified,
		);
	}

	private configureFloorAdhesion() {
		this.enabledSlots = [
			...this.enabledSlots,
			...(!context.get('experiments.desktopDrawer') ? ['floor_adhesion'] : []),
		];
	}
}
